import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('ProgressiveLoader', [
  'loadingItemWrapper',
  'loadingItem',
]);

const getProgressiveLoaderCss = css`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;

  .${classes.loadingItemWrapper} {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;

    .${classes.loadingItem} {
      margin: 0 auto;
    }
  }
`;

export default getProgressiveLoaderCss;
